module.exports = __webpack_public_path__ + "readmeTemplates/OSH_specifications.a5eb81d2fda85967f3f6aaa149f190f4.md";